// extracted by mini-css-extract-plugin
export var content = "WallboxSection-module--content--460c3";
export var hero = "WallboxSection-module--hero--4daf8";
export var heroContent = "WallboxSection-module--hero-content--57c86";
export var images = "WallboxSection-module--images--240e8";